// Imports Icons

export const LANGUAGE = {
  ENGLISH: "en",
};

export const customBreakpoints = {
  "320px": 320,
  "360px": 360,
  "380px": 380,
  "480px": 480,
  "520px": 520,
  "640px": 640,
  "680px": 680,
  "768px": 768,
  "920px": 920,
  "1024px": 1024,
  "1280px": 1280,
  "1536px": 1536,
};

export const AUTH_POPUP_VARIANTS = {
  SIGNIN: "signin",
  FORGOT_PASSWORD: "forgot_password",
  RESET_PASSWORD: "reset_password",
};

export const firebaseUplaodFolders = {
  F_OFFERS: "offers",
  F_ORDERS: "orders",
  F_PROFILE_PICTURES: "profilepictures",
  F_MESSAGES: "messages",
  F_MESSAGES_ATTACHMENTS: "message_attachments",
  F_LOGO: "companylogos",
};

export const referencesFormats = {
  JPEG_JPG: { mime: "image/jpeg", extensions: [".jpeg", ".jpg"] },
  PNG: { mime: "image/png", extensions: [".png"] },
  PDF: { mime: "application/pdf", extensions: [".pdf"] },
  DOC: { mime: "application/msword", extensions: [".doc"] },
  DOCX: {
    mime: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    extensions: [".docx"],
  },
  XLSX: {
    mime: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    extensions: [".xlsx"],
  },
  PPTX: {
    mime: "application/vnd.openxmlformats-officedocument.presentationml.presentation",
    extensions: [".pptx"],
  },
  CSV: { mime: "text/csv", extensions: [".csv"] },
  TXT: { mime: "text/plain", extensions: [".txt"] },
  ZIP: { mime: "application/zip", extensions: [".zip"] },
  RAR: { mime: "application/vnd.rar", extensions: [".rar"] },
};

export const maximumImagesUploadingSizes = {
  size_300KB: 0.3, // 300KB
  size_450KB: 0.45, // 300KB
  size_1MB: 1, // 300KB
};

export const BUTTON_VARIANT = {
  PRIMARY: "primary",
  SECONDARY: "secondary",
  OUTLINE: "outline",
  GHOST: "ghost",
  PLAIN: "plain",
  ICON: "icon",
  LINK: "link",
  SUCCESS: "success",
  ERROR: "error",
  THEME: "theme",
  BORDER_GRADIENT: "border-gradient",
  PRIMARY_NEXT: "primary-next",
  LOGIN: "login",
  LOGIN2: "login2",
  EDIT: "edit",
};

export const AVATAR_VARIANT = {
  ROUNDED: "rounded-lg",
  CIRCLE: "rounded-full",
  SQUARE: "rounded-none",
};

export const userTypes = {
  SUPER_CLIENT: "super_client",
  SUB_CLIENT: "sub_client",
  SUPER_ADMIN: "super_admin",
  SUB_ADMIN: "sub_admin",
};

export const PAYMENT_CONFIG = {
  SERVICE_FEE_PERCENTAGE: 10,
  DISCOUNT_PERCENTAGE: 5,
};

// Stripe Express Supported Countries
export const SUPPORTED_COUNTRIES = [
  // North America
  { code: "US", name: "United States" },
  { code: "CA", name: "Canada" },
  { code: "MX", name: "Mexico" },

  // Europe
  { code: "GB", name: "United Kingdom" },
  { code: "DE", name: "Germany" },
  { code: "FR", name: "France" },
  { code: "ES", name: "Spain" },
  { code: "IT", name: "Italy" },
  { code: "NL", name: "Netherlands" },
  { code: "BE", name: "Belgium" },
  { code: "DK", name: "Denmark" },
  { code: "IE", name: "Ireland" },
  { code: "NO", name: "Norway" },
  { code: "SE", name: "Sweden" },
  { code: "FI", name: "Finland" },
  { code: "AT", name: "Austria" },
  { code: "PT", name: "Portugal" },
  { code: "CH", name: "Switzerland" },
  { code: "LU", name: "Luxembourg" },

  // Asia Pacific
  { code: "JP", name: "Japan" },
  { code: "SG", name: "Singapore" },
  { code: "HK", name: "Hong Kong" },

  // Oceania
  { code: "AU", name: "Australia" },
  { code: "NZ", name: "New Zealand" },

  // Others
  { code: "AE", name: "United Arab Emirates" },
  { code: "IN", name: "India" },
  { code: "BR", name: "Brazil" },
  { code: "LK", name: "Sri Lanka" },
];
